// DynamicFieldRenderer.jsx
import React from "react";
import { memo, useState } from "react";
import TableTextBoxComponent from "./TableTextBoxComponent";
import TableMultiLineInputComponent from "./TableMultiLineInputComponent";
import TableBarCode from "./TableBarCode";
import TableQuantityInputComponent from "./TableQuantityInputComponent";
import TableSelectField from "./TableSelectField";

import TableELLSelectField from "./TableELLSelectField";
import TableLabSelectField from "./TableLabSelectField";
import TableILISelectField from "./TableILISelectField";
import TableELCSelectField from "./TableELCSelectField";
import { TableCheckbox } from "./TableCheckbox";
import CatalogLabelField from "./CatalogLabelField";
import CatalogDropdownField from "./CatalogDropdownField";
import CatalogTextboxField from "./CatalogTextboxField";
import TableLLIField from "./TableLLIField";

const DynamicFieldRenderer = ({
  element,
  tableName,
  tdkeys,
  name,
  values,
  setFieldValue,
  error,
  errorBorder,
  id,
  rowkeys,
  showInputQuantity,
  showWastageOption,
  setTotalSum,
  setTotalInputSum,
  props,
  childOpt,
  pageId,
  schemaItem,
  option,
  csvUplaodEnabled,
  catDropDown,
  setCatDropDown,
  ELCDropDown,
  setELCDropDown,
  loadingStates,
  setCatTabData,
  schemaPageFields,
  itemId,
  parentvalue,
  resetELCList,
  handleResetELCList,
  schemaPageId,
  schemaResult,
  searchParams,
  parentELCValue,
  handleSetOptionsForChild,
  ELLValue,
  ELLSchemaItem,
  childOptions,
  setParentELCValue,
  store_grp,
  user_id,
  handleELLValue,
  tableELLValue,
  handleTableELLValueChange,
  formData,
  handleELLVSchemaItem,
  fetchParentELCHeaderData,
}) => {
  // EDI readonly: disable fields whose fieldName is NOT in the editable list
  const ediEditableFields = props?.ediEditableFields || [];
  const ediDisabled = props?.ediReadonlyMode && !ediEditableFields.includes(name);
  switch (element.prefix) {
    case "LABEL":
      return <label>{element.key + 1}</label>;

    case "STC": {
      const isVisible = csvUplaodEnabled || element.visible !== false;
      if (!isVisible) return null;

      const fieldValue = values?.[tableName]?.[tdkeys]?.[name];
      const hasElementValue = element.value !== null && element.value !== undefined && element.value !== "";
      const displayValue = hasElementValue ? element.value : fieldValue;

      return (
        <label name={`${tableName}[${tdkeys}].${name}`} value={fieldValue}>
          {displayValue}
        </label>
      );
    }

    case "TXT":
      return (
        <TableTextBoxComponent
          data-testid="testIdtestKey1"
          element={element}
          tableName={tableName}
          tdkeys={tdkeys}
          name={name}
          values={values}
          setFieldValue={setFieldValue}
          error={error}
          errorBorder={errorBorder}
          id={id}
          rowkeys={rowkeys}
          disabled={ediDisabled}
        />
      );

    case "MLT":
      return (
        <TableMultiLineInputComponent
          element={element}
          tableName={tableName}
          tdkeys={tdkeys}
          name={name}
          values={values}
          setFieldValue={setFieldValue}
          error={error}
          errorBorder={errorBorder}
          id={id}
          rowkeys={rowkeys}
          disabled={ediDisabled}
        />
      );

    case "BAR":
      return (
        <TableBarCode
          element={element}
          tableName={tableName}
          tdkeys={tdkeys}
          name={name}
          values={values}
          setFieldValue={setFieldValue}
          error={error}
          errorBorder={errorBorder}
          id={id}
          rowkeys={rowkeys}
          disabled={ediDisabled}
        />
      );

    case "QTY":
      return (
        <TableQuantityInputComponent
          element={element}
          tableName={tableName}
          tdkeys={tdkeys}
          name={name}
          values={values}
          setFieldValue={setFieldValue}
          error={error}
          errorBorder={errorBorder}
          id={id}
          rowkeys={rowkeys}
          showInputQuantity={showInputQuantity}
          showWastageOption={showWastageOption}
          setTotalSum={setTotalSum}
          setTotalInputSum={setTotalInputSum}
          props={props}
        />
      );

    case "SLI":
      return (
        <TableSelectField
          element={element}
          option={option}
          error={error}
          id={id}
          tdkeys={tdkeys}
          rowkeys={rowkeys}
          tableName={tableName}
          name={name}
          errorBorder={errorBorder}
          values={values}
          childOpt={childOpt}
          pageId={pageId}
          schemaItem={schemaItem}
          disabled={ediDisabled}
        />
      );

    case "LLI":
      return (
        <TableLLIField
          element={element}
          childOpt={childOpt}
          pageId={pageId}
          schemaItem={schemaItem}
          option={option}
          error={error}
          id={id}
          tdkeys={tdkeys}
          rowkeys={rowkeys}
          tableName={tableName}
          name={name}
          errorBorder={errorBorder}
          values={values}
          disabled={ediDisabled}
        />
      );

    case "ELL":
      return (
        <TableELLSelectField
          element={element}
          childOpt={childOpt}
          pageId={pageId}
          schemaItem={schemaItem}
          option={option}
          error={error}
          id={id}
          tdkeys={tdkeys}
          rowkeys={rowkeys}
          tableName={tableName}
          name={name}
          errorBorder={errorBorder}
          setFieldValue={setFieldValue}
          handleResetELCList={handleResetELCList}
          handleELLValue={handleELLValue}
          handleTableELLValueChange={handleTableELLValueChange}
          formData={formData}
          disabled={ediDisabled}
        />
      );

    case "LAB":
      return (
        <TableLabSelectField
          element={element}
          childOpt={childOpt}
          pageId={pageId}
          schemaItem={schemaItem}
          option={option}
          error={error}
          id={id}
          tdkeys={tdkeys}
          rowkeys={rowkeys}
          tableName={tableName}
          name={name}
          errorBorder={errorBorder}
          csvUplaodEnabled={csvUplaodEnabled}
          disabled={ediDisabled}
        />
      );

    case "ILI":
      return (
        <TableILISelectField
          element={element}
          childOpt={childOpt}
          pageId={pageId}
          schemaItem={schemaItem}
          option={option}
          error={error}
          id={id}
          tdkeys={tdkeys}
          rowkeys={rowkeys}
          tableName={tableName}
          name={name}
          errorBorder={errorBorder}
          values={values}
          disabled={ediDisabled}
        />
      );

    case "ELC":
      return (
        <TableELCSelectField
          element={element}
          childOpt={childOpt}
          pageId={pageId}
          schemaItem={schemaItem}
          option={option}
          error={error}
          id={id}
          tdkeys={tdkeys}
          rowkeys={rowkeys}
          tableName={tableName}
          name={name}
          errorBorder={errorBorder}
          resetELCList={resetELCList}
          ELLValue={ELLValue}
          setFieldValue={setFieldValue}
          itemId={itemId}
          parentvalue={parentvalue}
          schemaPageFields={schemaPageFields}
          schemaPageId={schemaPageId}
          schemaResult={schemaResult}
          values={values}
          handleResetELCList={handleResetELCList}
          searchParams={searchParams}
          setOptionsForChild={handleSetOptionsForChild}
          parentELCValue={parentELCValue}
          childOptions={childOptions}
          setParentELCValue={setParentELCValue}
          ELCDropDown={ELCDropDown}
          setELCDropDown={setELCDropDown}
          loadingStates={loadingStates}
          tableELLValue={tableELLValue[tdkeys]}
          ELLSchemaItem={ELLSchemaItem}
          handleELLVSchemaItem={handleELLVSchemaItem}
          fetchParentELCHeaderData={fetchParentELCHeaderData}
          disabled={ediDisabled}
        />
      );

    case "CHK":
      let value = values?.[tableName]?.[tdkeys]?.[name] || "N";
      return (
        <TableCheckbox name={`${tableName}[${tdkeys}].${name}`} value={value} disabled={ediDisabled} />
      );

    case "CAT":
      if (element.catalogueSchemaType === 7) {
        return (
          <CatalogLabelField
            element={element}
            values={values}
            name={name}
            tableName={tableName}
            tdkeys={tdkeys}
          />
        );
      }
      if (element.catalogueSchemaType === 3) {
        return (
          <CatalogDropdownField
            element={element}
            values={values}
            name={name}
            tableName={tableName}
            tdkeys={tdkeys}
            catDropDown={catDropDown}
            setCatDropDown={setCatDropDown}
            setFieldValue={setFieldValue}
            loadingStates={loadingStates}
            error={error}
            setCatTabData={setCatTabData}
            schemaPageFields={schemaPageFields}
            store_grp={store_grp}
            user_id={user_id}
          />
        );
      }
      if (element.catalogueSchemaType === 1) {
        return (
          <CatalogTextboxField
            element={element}
            values={values}
            name={name}
            tableName={tableName}
            tdkeys={tdkeys}
            setFieldValue={setFieldValue}
            error={error}
            catDropDown={catDropDown}
            schemaPageFields={schemaPageFields}
            setCatTabData={setCatTabData}
            setCatDropDown={setCatDropDown}
            store_grp={store_grp}
            user_id={user_id}
          />
        );
      }
      return null;

    default:
      return null;
  }
};

// // Only re-render when relevant cell props change
// const areEqual = (prev, next) => {
//   // static identifiers
//   if (prev.element !== next.element) return false;
//   if (prev.tdkeys !== next.tdkeys || prev.name !== next.name) return false;
//   // value change
//   const prevVal = prev.values?.[prev.tableName]?.[prev.tdkeys]?.[prev.name];
//   const nextVal = next.values?.[next.tableName]?.[next.tdkeys]?.[next.name];
//   if (prevVal !== nextVal) return false;
//   // error change
//   if (prev.errorBorder !== next.errorBorder) return false;
//   // select options
//   if (prev.option !== next.option) return false;
//   if (prev.childOpt !== next.childOpt) return false;
//   // catalogue and ELC dropdowns
//   if (prev.catDropDown !== next.catDropDown) return false;
//   if (prev.ELCDropDown !== next.ELCDropDown) return false;
//   // loading state for this cell
//   if (prev.loadingStates?.[prev.tdkeys] !== next.loadingStates?.[next.tdkeys])
//     return false;
//   // tableELLValue change - check if the ELL value for this row has changed
//   if (prev.tableELLValue !== next.tableELLValue) return false;
//   return true;
// };
export const validateELCNoDuplicates = (values, tableName, schemaPageFields = []) => {
  const tableRows = values?.[tableName];
  const result = { hasDuplicates: false, details: [] };
  if (!tableRows || !Array.isArray(tableRows)) return result;

  // Collect ELC fieldNames from the TAB matching the tableName
  const elcFieldNames = [];
  try {
    (schemaPageFields || [])
      .filter(tab => tab?.prefix === "TAB" && (tab?.fieldName === tableName || tab?.name === tableName))
      .forEach(tab => {
        (tab?.schemaPageSubItems || []).forEach(si => {
          if (si?.prefix === "ELC") {
            const fn = typeof si?.fieldName === "string" ? si.fieldName.trim() : "";
            if (fn) elcFieldNames.push(fn);
          }
        });
      });
  } catch (_) {
    // ignore
  }

  const normalize = (v) => {
    const s = String(v || "").trim();
    return s.toLowerCase();
  };

  const isNaOrEmpty = (v) => {
    const s = String(v || "").trim();
    return s.length === 0 || s.toLowerCase() === "n/a";
  };

  tableRows.forEach((rowObj, rowIndex) => {
    if (!rowObj || typeof rowObj !== "object") return;

    const rowKeys = Object.keys(rowObj);
    // Map schema fieldNames to actual row keys (case-insensitive)
    const candidateCols = elcFieldNames
      .map(schemaName => {
        const target = schemaName.toLowerCase();
        const match = rowKeys.find(k => k.toLowerCase() === target);
        return match || null;
      })
      .filter(Boolean);

    // If no ELC columns are present in this row, skip validation for this row
    if (candidateCols.length === 0) return;

    const seen = new Map(); // norm -> { value, columns: [] }
    candidateCols.forEach(col => {
      const v = rowObj[col];
      if (isNaOrEmpty(v)) return;
      const norm = normalize(v);
      if (!norm) return;
      const display = String(v || "").trim();
      if (!seen.has(norm)) {
        seen.set(norm, { value: display, columns: [col] });
      } else {
        const entry = seen.get(norm);
        entry.columns.push(col);
      }
    });

    const dups = Array.from(seen.values()).filter(e => e.columns.length > 1);
    if (dups.length) {
      result.hasDuplicates = true;
      result.details.push({ rowIndex, duplicates: dups });
    }
  });

  return result;
};

/**
 * Convert validateELCNoDuplicates result into Formik-compatible error object.
 * Keys will be like: `${tableName}[rowIndex].${column}`
 * Value is a short error message for each duplicate column.
 */
export const buildELCDuplicateErrors = (tableName, validationResult) => {
  const errors = {};
  if (!validationResult?.hasDuplicates) return errors;

  validationResult.details.forEach(({ rowIndex, duplicates }) => {
    duplicates.forEach(({ value, columns }) => {
      const msg = `Duplicate Secondary Sizing "${value}" in row ${rowIndex + 1}`;
      columns.forEach((col) => {
        errors[`${tableName}[${rowIndex}].${col}`] = msg;
      });
    });
  });

  return errors;
};

export default DynamicFieldRenderer;
//export default memo(DynamicFieldRenderer, areEqual);
